<template>
  <div class="km-page">
    <header class="km-top">
      <button class="km-back" @click="back()" aria-label="Back">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
      </button>
      <div class="km-top__title"><span class="km-top__dot"></span><h1>{{ $t('my.online_service') }}</h1></div>
      <div style="width:38px"></div>
    </header>

    <main class="km-main">
      <section class="km-section">
        <!-- Live card -->
        <div class="kcs-hero">
          <div class="kcs-hero__bg"></div>
          <img class="kcs-hero__avatar" src="/img/mine/kefu.png" alt="support"/>
          <div class="kcs-hero__body">
            <h3>{{ serviceTitle }} support</h3>
            <p>
              <span class="kcs-online-dot"></span>
              Online · we usually reply in a few minutes
            </p>
          </div>
        </div>
      </section>

      <section class="km-section" v-if="channels.length">
        <div class="km-sec-head">Contact us</div>
        <div class="km-card">
          <a
            v-for="(ch, i) in channels" :key="i"
            class="km-row"
            :href="ch.href" :target="ch.target || '_self'" rel="noopener"
            style="text-decoration:none"
          >
            <span class="km-row__ico" :style="{ background: ch.color }">{{ ch.emoji }}</span>
            <div class="kcs-body">
              <span class="kcs-label">{{ ch.label }}</span>
              <span class="kcs-value">{{ ch.value }}</span>
            </div>
            <span class="km-row__chev">›</span>
          </a>
        </div>
      </section>

      <section v-else class="km-section">
        <div class="km-empty">
          <div class="km-empty__emoji">💬</div>
          <h3>{{ $t('withdraw.empty_data') }}</h3>
          <p>Support channels will appear here once configured.</p>
        </div>
      </section>

      <section class="km-section" v-if="hoursLabel">
        <div class="kcs-hours">🕓 {{ hoursLabel }}</div>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  data() { return {}; },
  computed: {
    baseInfo() { return (this.$store && this.$store.getters && this.$store.getters.getBaseInfo) || {}; },
    serviceTitle() { return this.baseInfo.name || this.$t('my.title'); },
    hoursLabel() {
      var h = (this.baseInfo.cs_hours || '').trim();
      if (h) return h;
      return this.$t('my.service_time');
    },
    channels() {
      var b = this.baseInfo || {};
      var items = [];
      var tg = (b.cs_telegram || '').trim();
      if (tg) {
        var tgHref = tg;
        if (/^@/.test(tg)) tgHref = 'https://t.me/' + tg.slice(1);
        else if (!/^https?:/i.test(tg) && !/^tg:/i.test(tg)) tgHref = 'https://t.me/' + tg.replace(/^\/+/, '');
        items.push({ emoji: '✈️', label: 'Telegram', value: tg, href: tgHref, target: '_blank', color: 'linear-gradient(135deg,#60a5fa,#3b82f6)' });
      }
      var wa = (b.cs_whatsapp || '').trim();
      if (wa) {
        var waDigits = wa.replace(/[^\d+]/g, '').replace(/^\+/, '');
        items.push({ emoji: '💬', label: 'WhatsApp', value: wa, href: 'https://wa.me/' + waDigits, target: '_blank', color: 'linear-gradient(135deg,#34d399,#10b981)' });
      }
      var ph = (b.cs_phone || '').trim();
      if (ph) {
        items.push({ emoji: '📞', label: this.$t('setting.mobile'), value: ph, href: 'tel:' + ph.replace(/\s/g, ''), color: 'linear-gradient(135deg,#fbbf24,#f59e0b)' });
      }
      var em = (b.cs_email || '').trim();
      if (em) {
        items.push({ emoji: '✉️', label: 'Email', value: em, href: 'mailto:' + em, color: 'linear-gradient(135deg,#c084fc,#a020f0)' });
      }
      return items;
    }
  },
  methods: { back() { return window.history.back(); } }
};
</script>

<style lang="less" scoped>
@import "./_km-page.less";

.kcs-hero {
  position: relative; overflow: hidden;
  display: flex; align-items: center; gap: 14px;
  background: linear-gradient(135deg, #1a1033 0%, #4a1a6e 100%);
  color: #fff;
  border-radius: 18px;
  padding: 18px 20px;
  box-shadow: 0 14px 36px rgba(74,26,110,.25);
}
.kcs-hero__bg {
  position: absolute; inset: 0;
  background:
    radial-gradient(circle at 15% 20%, rgba(255,77,141,.45), transparent 55%),
    radial-gradient(circle at 90% 80%, rgba(160,32,240,.45), transparent 55%);
  pointer-events: none;
}
.kcs-hero__avatar {
  position: relative;
  width: 60px; height: 60px; border-radius: 50%;
  border: 3px solid rgba(255,255,255,.35); background: #fff;
  box-shadow: 0 6px 16px rgba(0,0,0,.25);
  flex-shrink: 0;
}
.kcs-hero__body { position: relative; flex: 1; min-width: 0; }
.kcs-hero__body h3 { margin: 0 0 2px; font-size: 16px; font-weight: 800; letter-spacing: -.01em; }
.kcs-hero__body p {
  margin: 0; font-size: 12px; opacity: .85;
  display: flex; align-items: center; gap: 6px;
}
.kcs-online-dot {
  width: 8px; height: 8px; border-radius: 50%; background: #10b981;
  box-shadow: 0 0 0 3px rgba(16,185,129,.35);
  animation: kcsPulse 1.6s ease-in-out infinite;
}
@keyframes kcsPulse { 0%,100% { transform: scale(1); } 50% { transform: scale(1.3); } }

.kcs-body { flex: 1; display: flex; flex-direction: column; min-width: 0; }
.kcs-label { font-size: 14px; font-weight: 700; color: #2a1a3f; }
.kcs-value { font-size: 12px; color: #8273a0; margin-top: 2px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

.kcs-hours {
  text-align: center; font-size: 12px; color: #8273a0;
  padding: 10px 14px; border-radius: 12px;
  background: rgba(255,77,141,.05); border: 1px solid rgba(255,77,141,.1);
  font-weight: 500;
}

.km-empty { text-align: center; padding: 40px 20px; color: #6b5c85; }
.km-empty__emoji { font-size: 46px; margin-bottom: 8px; }
.km-empty h3 { margin: 0 0 4px; font-size: 15px; color: #2a1a3f; }
.km-empty p { margin: 0; font-size: 12px; }
</style>
